<template>
  <div class>
    <div
      slot="header"
      class="clearfix"
      style="background-color: #f2f2f2; padding: 20px"
    >
      <span style="font-weight: 600; color: #000; line-height: 10px"
        >告警信息</span
      >
      <el-button
        type="success"
        plain
        @click="cancel"
        style="float: right; padding: 3px 0"
        >返回</el-button
      >
    </div>
    <SForm
      ref="formref"
      :fields="formfields"
      :dataForm="tableData"
      labelWidth="150px"
      :isShowBtn="false"
      :inline="false"
    >
    </SForm>
    <div class="clearfix" style="background-color: #f2f2f2; padding: 20px">
      <span style="font-weight: 600; color: #000; line-height: 10px"
        >设备信息</span
      >
    </div>
    <SForm
      ref="formrefDevice"
      :fields="formfieldsDevice"
      :dataForm="tableData"
      labelWidth="150px"
      :isShowBtn="false"
      :inline="false"
    >
    </SForm>
  </div>
</template>

<script>
import { HOST, EV_HOST } from "@/utils/host";
const token = window.localStorage.getItem("token");
export default {
  name: "batteryAlarmDetail",
  components: {},
  data() {
    return {
      rowdata: {},
      rowdataDevice: {},
      formfields: [
        {
          label: "告警原因",
          type: "div",
          prop: "reason"
        },
        {
          label: "告警等级",
          type: "div",
          prop: "alarmLevel"
        },
        {
          label: "告警时间",
          type: "div",
          prop: "alarmTime"
        },
        {
          label: "告警码",
          type: "div",
          prop: "alarmCode"
        },
        // {
        //   label: "异常值",
        //   type: "div",
        //   prop: "abnormalValue",
        // },
        {
          label: "告警来源",
          type: "div",
          prop: "alarmSource"
        },
        {
          label: "短息通知",
          type: "div",
          prop: "sendSms"
        }
      ],
      formfieldsDevice: [
        {
          label: "SN号",
          type: "div",
          prop: "SN"
        },
        {
          label: "设备名称",
          type: "div",
          prop: "deviceName"
        },
        {
          label: "品牌型号",
          type: "div",
          prop: "brandModel"
        },
        {
          label: "项目名称",
          type: "div",
          prop: "projectName"
        },
        {
          label: "企业名称",
          type: "div",
          prop: "companyName"
        }
      ],
      id: "",
      tableData: []
    };
  },
  computed: {},
  methods: {
    cancel() {
      this.$router.go(-1);
    }
  },
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {
    this.tableData = this.$route.query.data;
  }, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang="less" src="" scoped>
.resetbtn:hover {
  border: 1px solid #00cc00;
  color: #00cc00;
}
.resetbtn:active {
  border: 1px solid #00cc00;
  color: #ffffff;
  background-color: #00cc00;
}
</style>



// WEBPACK FOOTER //
// src/views/BMS/alarmManagement/batteryAlarm/BatteryAlarmDetail.vue